import { Button } from '@app/components/various/Button';
import { HelpOutline } from '@app/components/various/Icons';
import { useModalVisibility } from '@app/utils/hooks';
import { useTranslation } from 'react-i18next';

export const MatrixHelpIcon = () => {
  const { t } = useTranslation(['common', 'products']);
  const { showModal } = useModalVisibility('MatrixHelpModal');

  return (
    <Button
      dataTestId="matrixHelpIcon"
      variant="text"
      color="secondary"
      icon={HelpOutline}
      onClick={showModal}
      aria-label={t('products:show_product_matrix_help')}
      className="text-neutral-60"
    />
  );
};
